import {Component, Inject, Input, OnInit} from '@angular/core';
import {Init} from "@alloyidentity/web-sdk/dist/types";
import {environment} from "../../../../environments/environment";
import {
  ALLOY_ANCHOR_ELEMENT,
  ALLOY_SDK_PRIMARY_COLOR_KEY,
  ALLOY_SDK_SECONDARY_COLOR_KEY
} from "../../constants";
import alloy from "@alloyidentity/web-sdk";
import {FacadeService} from "../../service-facade/facade.service";
import {ProcessService} from "../../../process/process.service";
import {DOCUMENT} from "@angular/common";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-alloy-sdk-frame',
  templateUrl: './alloy-sdk-frame.component.html',
  styleUrls: ['./alloy-sdk-frame.component.css']
})
export class AlloySdkFrameComponent implements OnInit {

  alloyEntityTokenId : string = "";

  private sdkKey: string = "";
  private journeyToken: string = "";
  private journeyApplicationToken: string = "";

  constructor(private facadeService: FacadeService,
              private processService: ProcessService,
              private route: ActivatedRoute,
              @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.alloyEntityTokenId = this.route.snapshot.queryParamMap.get('alloyEntityTokenId')!;
    this.sdkKey = this.route.snapshot.queryParamMap.get('sdkKey')!;
    this.journeyToken = this.route.snapshot.queryParamMap.get('journeyToken')!;
    this.journeyApplicationToken = this.route.snapshot.queryParamMap.get('journeyApplicationToken')!;

    this.initializeAlloySdk();
  }

  private initializeAlloySdk() {
    const alloyInitParams: Init = {
      key: this.sdkKey,
      journeyToken: this.journeyToken,
      journeyApplicationToken: this.journeyApplicationToken,
      entityToken: this.alloyEntityTokenId, // Pass in the Alloy Entity Token that was returned back to us from createJourney.
      isSingleEntity: true, // This is true because we are opening a single Document Capture SDK Session.
      production: environment.alloyIsInProductionEnvironment,
      color: {
        primary: this.facadeService.getStorageItem(ALLOY_SDK_PRIMARY_COLOR_KEY),
        secondary: this.facadeService.getStorageItem(ALLOY_SDK_SECONDARY_COLOR_KEY)
      },
      showHeader: false
    };

    alloy.init(alloyInitParams).then(() => {
      // Hook to the HTML DOM Element based on tab index. Register the empty method below as the callback.
      // If we did not use webhooks then we would depend on this callback for state management but since we have webhooks we are not required to take action in that method.
      alloy.open(this.processDocumentCaptureResponse, ALLOY_ANCHOR_ELEMENT);
    });
  }

  private processDocumentCaptureResponse() { }
}
